<template>
    <div>
        <frm-overview
            ref="overview"
            :config="overviewConfig"
            @xhr="meta = $event.meta"
            @xhr.once="scrollToClosest($event)"
        >
            <template #actions>
                <p v-if="metaFormatted" class="meta">
                    {{ metaFormatted }}
                </p>
            </template>
        </frm-overview>
    </div>
</template>

<script>

export default {
    props: {
        overviewConfig: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            meta: {},
        };
    },

    computed: {
        metaFormatted() {
            if (!Object.keys(this.meta).length) {
                return '';
            }

            const meta = [];

            if (this.meta.total_count) {
                meta.push(this.$t('calendar.search.meta.total', { count: this.meta.total_count }));
            }

            if (this.meta.leading_count) {
                meta.push(this.$t('calendar.search.meta.leading', { count: this.meta.leading_count }));
            }

            if (this.meta.trailing_count) {
                meta.push(this.$t('calendar.search.meta.trailing', { count: this.meta.trailing_count }));
            }

            return meta.join(', ');
        },
    },

    methods: {
        scrollToClosest(json) {
            const closest = [...json.data].reverse().find(item => !!item.is_future);

            if (closest) {
                this.$refs.overview.selectRow(closest.id);
            }
        },
    },

};
</script>

<style lang="scss" scoped>
.meta {
    display: flex;
    font-weight: bold;
    margin: 0;
    gap: .5rem;
}
</style>
